module.exports = __webpack_public_path__ + "img/icons-40-perks-beach-office.1382a566.svg";